import { Mask, MaskList, Maskable } from '@/types';

const addressNumber = '#######';
const cellPhone = '(##) #####-####';
const telephone = '(##) ####-####';
const cellPhoneOrTelephone = [cellPhone, telephone];
const cnh = '###########';
const cnhSecurity = '###########';
const cnpj = '##.###.###/####-##';
const cpf = '###.###.###-##';
const cpfOrCnpj = [cpf, cnpj];
const plate = ['WWW-####', 'WWW#A##'];
const renavam = '###########';
const rntrc = '#########';
const year = '####';
const zipCode = '#####-###';

const cnhHidden = '***#####***';
const cnhSecurityHidden = '***#####***';
const renavamHidden = '***#####***';
const cpfHidden = '***#####***';
const cnpjHidden = '***########***';
const partiallyAnonymizedCellPhone = '(##) ###xx-xx##';

const cpfOrCnpjHidden = [cpfHidden, cnpjHidden];

export const masks: MaskList = {
  addressNumber,
  cellPhone,
  cellPhoneOrTelephone,
  cnh,
  cnhSecurity,
  cnpj,
  cpf,
  cpfOrCnpj,
  plate,
  renavam,
  rntrc,
  year,
  zipCode,
  cellPhoneAnonymyzed: partiallyAnonymizedCellPhone,
} as const;

const hiddenMasks: MaskList = {
  cnh: cnhHidden,
  cpfOrCnpj: cpfOrCnpjHidden,
  cnhSecurity: cnhSecurityHidden,
  renavam: renavamHidden,
  cellPhoneAnonymyzed: partiallyAnonymizedCellPhone,
} as const;

export const getMask = (mask: Maskable, hidden = false): Mask => {
  if (hidden && hiddenMasks[mask] !== undefined) return hiddenMasks[mask];
  return masks[mask];
};
